import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ActivatedAlertTimeWillBeOver } from "../../actions/SessionKonselingActions";
import useTrigerWaktu from "../../costumeHooks/useTrigetWaktu";
const moment = require("moment");

function secsToTime(secs) {
  let d = (secs / 8.64e4) | 0;
  let H = ((secs % 8.64e4) / 3.6e3) | 0;
  let m = ((secs % 3.6e3) / 60) | 0;
  let s = secs % 60;
  let z = (n) => (n < 10 ? "0" : "") + n;
  return `${z(H)}:${z(m)}:${z(s)}`;
}

const FULL = "FULL";
const SIMPLE = "SIMPLE";

export default function TimmerPduli({
  endTime,
  setComplete,
  mode = FULL,
  kode = "0000",
}) {
  //   const initialTime = () => {
  //     let now = moment();
  //     let then = moment(endTime);
  //     return then.diff(now, "seconds");
  //   };
  //   console.log(" testing time diff", initialTime);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [startCounting, setStartCounting] = useState(false);
  const { handleIsWillBeEnd, isWillBeEnd } = useTrigerWaktu();
  useEffect(() => {
    let now = moment();
    let then = moment(endTime, "YYYY-MM-DD HH:mm:ss");
    console.log(
      "VideoKonselingWatingOpen time then",
      endTime,
      then.format("YYYY-MM-DD HH:mm:ss")
    );
    setTimeRemaining(then.diff(now, "seconds"));
    setStartCounting(true);
    handleIsWillBeEnd(false);
  }, [endTime]);
  useEffect(() => {
    if (startCounting == true) {
      const timerInterval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (!isWillBeEnd && prevTime <= 300) {
            handleIsWillBeEnd(true);
          }
          if (prevTime === 0) {
            clearInterval(timerInterval);
            setComplete(true);
            // Perform actions when the timer reaches zero
            console.log("Countdown complete!");
            return 0;
          } else {
            return prevTime - 1;
          }
        });
      }, 1000);

      // Cleanup the interval when the component unmounts
      return () => clearInterval(timerInterval);
    }
  }, [startCounting]); // The empty dependency array ensures the effect runs only once on mount

  // Convert seconds to hours, minutes, and seconds
  const hours = Math.floor(timeRemaining / 3600);
  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const seconds = timeRemaining % 60;

  return (
    <div>
      {/* <p>{endTime}</p> */}
      {mode == FULL && (
        <p>{`${hours} Jam, ${minutes} Menit, ${seconds} Detik`}</p>
      )}
      {mode == SIMPLE && (
        <p>
          {hours != 0 && `${("0" + hours).slice(-2)}:`}
          {(hours != 0 || minutes != 0) && `${("0" + minutes).slice(-2)}:`}
          {`${("0" + seconds).slice(-2)}`}
        </p>
      )}
    </div>
  );
}
